import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prjectMgm, auditBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const projectMasterService = createApi({
    reducerPath: 'projectMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['ProjectMaster'],
    endpoints: (builder) => ({
        getAllProjectMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectMasterController.getAllProjectMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getProjectMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectMasterController.getProjectMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        saveProjectMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectMasterController.saveProjectMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updateProjectMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectMasterController.updateProjectMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deleteProjectMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.projectMasterController.deleteProjectMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getAllProjectMasterWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectMasterController.getAllProjectMasterWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllProjectMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.projectMasterController.findAllProjectMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllProjectMasterMutation,
    useSaveProjectMasterMutation,
    useUpdateProjectMasterMutation,
    useDeleteProjectMasterMutation,
    useGetProjectMasterByIdMutation,
    useGetAllProjectMasterWithSearchMutation,
    useFindAllProjectMasterMutation,
  } = projectMasterService;